<!--
 * @Description: 表格组件
 * @Autor: txp
 * @Date: 2021-04-22 10:14:52
-->
<template>
  <div class="tablecomponent">
    <el-table
      ref="orderTableId"
      :data="table_data"
      height="450px"
      :header-cell-style="{
        textAlign: 'center',
        fontSize: '13px',
        color: '#787878',
        background: '#F5F5F5'
      }"
      :cell-style="{ textAlign: 'center', fontSize: '14px', color: '#1D1D1D', lineHeight: '24px' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column label="全选" type="selection">
        <!-- v-if="table_config.checkbox" -->
      </el-table-column>
      <el-table-column :width="200" align="right" fixed="left" label="订单编号">
        <template slot-scope="scope">
          <p
            :style="'color:' + theme"
            class="cursorP"
            @click="toOrderDetail(scope.row.id)"
            type="text"
            size="small"
          >
            {{ scope.row.orderCode }}
          </p>
          <!-- <span  v-else>{{scope.row.orderCode}}</span> -->
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in table_config.thead"
        :key="index"
        :width="item.width"
        :prop="item.prop"
        :label="item.label"
      ></el-table-column>
      <el-table-column v-if="table_config.goshopOrderBool" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="findclick(scope.row)" type="text" size="small">去下单</el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" v-if="table_config.orderdetBool" label="发货详情">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state === '9' || scope.row.state === '8'"
            @click="drawerClick(scope.row)"
            type="text"
            size="small"
          >
            查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column :width="120" fixed="right" v-if="table_config.orderdetBool" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="
              (scope.row.state === '9' || scope.row.state === '8') &&
                scope.row.receivingStatus !== '2'
            "
            @click="theGoods(scope.row)"
            type="text"
            size="small"
          >
            收货
          </el-button>
          <!-- <div class="flex"> -->
          <!-- <el-button  type="text" size="small">撤回</el-button> -->

          <!-- </div> -->
          <template v-else-if="scope.row.state === '2'">
            <el-button
              @click="findclick(scope.row)"
              type="text"
              size="small"
            >
              去下单
            </el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              @click="cancel(scope.row)"
              type="text"
              size="small"
            >
              作废
            </el-button>

          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'tablecomponent',
  props: {
    table_config: {
      type: Object,
      default: function() {
        return {}
      }
    },
    table_data: {
      type: Array,
      default: function() {
        return []
      }
    },
    selectValList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      tableHeight: '',
      screenHeight: window.innerHeight
    }
  },
   watch: {
    screenHeight() {
      this.$nextTick(()=> {
      this.setPageHeight()
    })
    }
  },
  computed: {
    ...mapGetters({
      theme: 'theme'
    })
  },
   mounted() {
    this.$nextTick(()=> {
      this.setPageHeight()
    })
  },
  methods: {
       setPageHeight() {
      const pageHeight = window.innerHeight
      this.tableHeight = pageHeight - 550
    },
    /**
     * @description: 去下单，通过id，调用接口
     * @param {*} val
     * @return {*}
     * @author: txp
     */
    findclick(val) {
      this.$emit('findclick', val.id)
    },
    // 作废订单
    cancel(row){
      this.$emit('cancel', row.id)
    },
    // 查看我的订单详情 跳转到发货详情
    drawerClick(row) {
      // let params = {
      //     row,
      //     visible:true
      // }
      // this.$emit("drawerClicks",params)
      this.$router.push(`/home/main/deliveryDetail?orderCode=${row.orderCode}`)
    },
    // 获取我的订单状态类型
    stateType(state) {
      try {
        let states = this.selectValList.find((item) => {
          if (item.dictCode == state) {
            return item.dictValue
          }
        })
        return states.dictValue
      } catch {}
    },
    // 我的订单，跳转到结算详情页面
    toOrderDetail(id) {
      this.$emit('toOrderDetails', id)
    },
    // 获取选中的值
    handleSelectionChange(val) {
      this.$emit('multipleSelections', val)
    },
    //收货
    theGoods(row) {
      this.$router.push(`/home/main/theGoods?orderCode=${row.orderCode}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.tablecomponent {
  // 设置滚动条样式
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    background-color: #fafafa;
  }
}
</style>
